import { Modal } from 'antd';
import React, { useState } from 'react';
import DeleteWarningModalWithAction from '../../../components/Common/DeleteWarningModalWithAction';
import { addPricingOption } from '../../../services/pricing.service';
import PricingOptionForm from './PricingOptionForm';

const PricingOptionAdd = ({
  isOpen,
  toggle,
  status,
  setStatus,
  courses,
  courseOffers
}) => {
  const initialValues = {
    type: 'Type ',
    currency: 'USD',
    total: 0,
    discountEnabled: true,
    deposit: {
      type: 'percent',
      value: 50
    },
    countryWisePrice: [],
    pricePoints: [
      {
        number: 1.0,
        type: 'amount',
        discountValue: 0.0
      }
    ],
    localiseForAllCountries: false,
    creditsEnabled: true
  };
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(
    false
  );
  const [pricingFormValues, setpricingFormValues] = useState(
    initialValues
  );

  const onConfirm = async () => {
    await addPricingOption(pricingFormValues)
      .then((response) => {
        setStatus({
          type: 'SUCCESS',
          message: 'PricingOption added successfully!'
        });
      })
      .catch((error) => {
        alert('Posting data to the backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  const onSubmit = async (values) => {
    setIsConfirmModalVisible(true);
    setpricingFormValues(values);
  };

  return (
    <Modal
      title={`Add Pricing Option`}
      visible={isOpen}
      onCancel={() => toggle()}
      footer={null}>
      <PricingOptionForm
        type="Add"
        initialValues={initialValues}
        onSubmit={onSubmit}
        status={status}
        visible={isOpen}
        setStatus={setStatus}
        courses={courses}
        courseOffers={courseOffers}
        maxValue={100}
      />
      <DeleteWarningModalWithAction
        isVisible={isConfirmModalVisible}
        setIsVisible={setIsConfirmModalVisible}
        action={onConfirm}
        question={`Are You Sure You Want To Create Pricing Option ${
          pricingFormValues.currency
        } ${pricingFormValues.total} with Deposit ${
          pricingFormValues.deposit.value
        } ${pricingFormValues.deposit.type === 'percent' ? '%' : 'USD'}`}
        buttonLabel="Confirm"
      />
    </Modal>
  );
};

export default PricingOptionAdd;
